@if (needsSetup) {
    <div (click)="startSetup()" 
        class="onboarding-prompt">
        <mat-icon class="tw-mr-2">info</mat-icon>
        <span>{{ 'HISTORY.E_INVOICES.ONBOARDING_PROMPT' | translate }}</span>
    </div>
}

<div class="tw-flex tw-flex-col tw-h-full tw-overflow-hidden" [class.tw-hidden]="needsSetup">
    <div class="filter-chip-container tw-flex tw-flex-col tw-p-4">
        <mat-chip-listbox #eInvoicesChipList
            (change)="onFilterStatusChange($event.value)"
            [value]="currentStatus()"
            required="true">
            @for(s of statusConfig; track s.status) {
                @if(!s.hidden) {
                    <mat-chip-option [value]="s.status"
                        class="custom-chip tw-px-2 tw-py-0.5 tw-rounded-full tw-font-bold">
                        <div class="tw-flex tw-items-center tw-justify-between">
                            <span>{{ s.label }}</span>
                            <span class="chip-badge">{{ s.count }}</span>
                        </div>
                    </mat-chip-option>
                }
            }

        </mat-chip-listbox>
    </div>

    <div class="tw-flex-1 tw-min-h-0">
        <app-grid-server-side
            #eInvoicesGridComponent
            feature="history_e_invoices"
            [headerCheckboxSelection]="true"
            (areRowsSelected)="handleSelectionChange($event)"
            (rowClicked)="rowClicked($event)"
            (clickableAction)="actions($event)"
            (gridReadyEmitter)="onGridReady()"
            [cacheBlockSize]="query.per_page"
            [datasource]="datasource"
            [tableData]="tableData[0]"
            [fixedButtons]="fixedButtons"
            [exportFormatterOptions]="exportFormatterOptions"
            (sortChangedEmitter)="onSortChangedEmitter($event)"
            (filterChangedEmitter)="onFilterChangedEmitter($event)"
        ></app-grid-server-side>
    </div>
</div>
